import colors from '@web-ui-kit/colors'
import { FontFamily } from '@web-ui-kit/fonts'
import shadows from '@web-ui-kit/shadows'
import spaces from '@web-ui-kit/spaces'

// import { ThemeSchema } from '@frontend_vv/web-ui-kit.themes.theme-provider'
// El DefaultTheme debería seguir la estructura de ThemeSchema.
// No se añade la importación por que crea una dependencia circular.

const DefaultTheme = {
  colors: colors,
  fonts: {
    body: FontFamily.roboto,
    headline: FontFamily.comfortaa,
  },
  shadows: shadows,
  spaces: spaces,
}

export default DefaultTheme
